module.exports = __webpack_public_path__ + "media/images/qr/illustrated-qr-mono-48ceed9e2be3d03028134a0c895ec6a5.svg";